export default __webpack_public_path__ + "static/media/mb-resolved.7f479a43.svg";